import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let diagnoseQuery = new Parse.Query('MedicationDiagnosis');
	diagnoseQuery.notEqualTo("deleted", true)
	diagnoseQuery.find()
		.then((results) => {
			store.dispatch('diagnoses/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		diagnoseQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('diagnoses/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('diagnoses/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('diagnoses/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('diagnoses/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('diagnoses/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}

export default function createDiagnoseSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
